import { forgotPassword } from '../../../modules/auth/auth.repository';
import { ForgotPasswordPayload } from '../../../modules/auth/types';

export const setForgotPasswordUseCase = (payload: ForgotPasswordPayload) => {
  return forgotPassword(payload);
};
